// Libraries
import { IconProps } from '@chakra-ui/react';

export enum LogoViewBox {
  /**
   * viewBox values for base.
   */
  base = '0 0 1125 122',
  /**
   * viewBox values for name.
   */
  name = '0 0 214 59',
  /**
   * viewBox values for short.
   */
  short = '400 0 600 122',
  /**
   * viewBox values for ghost.
   */
  ghost = '0 0 123 26',
}

/**
 * Type of logo to display.
 */
export enum LogoType {
  /**
   * Display the basic logo.
   */
  base = 'base',
  /**
   * Display the basic logo whit the name below.
   */
  name = 'name',
  /**
   * Display short version of the logo.
   */
  short = 'short',
  /**
   * Display the ghost version of the logo.
   */
  ghost = 'ghost',
}

/**
 * Props for the RatingsIcon component.
 */
export type BearingLogoProps = IconProps & {
  /**
   * The rating key, which should be one of the keys defined in the Rating enum.
   */
  logoType?: keyof typeof LogoType;
};
